<div class="devices-wrapper">
  <ng-container
    *ngIf="
      selectedPlan === BookingPlans.Trial && !devices && !devices?.length && !searchTerm;
      else displayDevicesList
    "
  >
    <div
      class="error-container flex flex-col gap-[16px] lt-md:gap-[8px] justify-start items-center"
    >
      <img src="assets/img/installer-error.svg" />
      <h2>{{ '+BOOKING.PLANS.ERROR.TITLE' | translate }}</h2>
      <button
        class="back-button"
        gtm="onGoToPage"
        gtmAction="Home Page"
        gtmCategory="booking"
        mat-raised-button
        color="primary"
        [routerLink]="['/installations']"
      >
        <mat-icon>arrow_back</mat-icon>
        <span>{{ '+BOOKING.PLANS.ERROR.BTN' | translate }}</span>
      </button>
    </div>
  </ng-container>
  <ng-template #displayDevicesList>
    <h1 class="devices-title">
      {{ '+BOOKING.DEVICES.TITLE' | translate }}
    </h1>
    <div class="devices-content">
      <div class="devices-list-wrapper">
        <div class="devices-list">
          <ng-container [ngSwitch]="selectedPlan">
            <h3 *ngSwitchCase="BookingPlans.Plus" class="devices-list-header">
              {{ '+BOOKING.DEVICES.PLUS_LIST_DESCRIPTION' | translate }}
            </h3>
            <h3 *ngSwitchCase="BookingPlans.Pro" class="devices-list-header">
              {{ '+BOOKING.DEVICES.PRO_LIST_DESCRIPTION' | translate }}
            </h3>
            <h3 *ngSwitchCase="BookingPlans.Trial" class="devices-list-header">
              {{ '+BOOKING.DEVICES.PRO_TRIAL_LIST_DESCRIPTION' | translate }}
            </h3>
          </ng-container>
          <div
            *ngIf="selectedPlan !== BookingPlans.Trial && !invoiceNumber"
            class="devices-counter"
          >
            {{ '+BOOKING.DEVICES.SELECTED_DEVICES_INFO' | translate }}
          </div>
          <div class="devices-counter" [attr.data-at-devices-counter]="selectedInstallationsCount">
            {{
              '+BOOKING.DEVICES.SELECTED_DEVICES'
                | translate
                  : {
                      selected: selectedInstallationsCount,
                      available: maxSelectedDevices
                    }
            }}
          </div>
          <app-booking-devices-list>
            <app-installation-search
              search
              data-at-search-field
              [searchTerm]="searchTerm"
              [disabled]="devices && !devices.length && !searchTerm"
              categoryForGtm="booking"
              (search)="search($event)"
            ></app-installation-search>
            <ng-container
              *ngIf="bookingStore.isBookingDevicesLoading$ | async; else deviceList"
              installation-item
            >
              <vi-loader [isLoading]="true"></vi-loader>
            </ng-container>
            <ng-template #deviceList installation-item>
              <ng-container
                *ngIf="bookingStore.devicesCount$ | async; else noDevices"
                installation-item
              >
                <app-bookable-installation
                  *ngFor="let device of bookingStore.bookingDevicesWithFilterAndPagination$ | async"
                  class="devices-list-entry"
                  installation-item
                  data-at-device
                  [attr.data-at-checked]="isSelectedInstallation(device) | async"
                  [device]="device"
                  [invoiceNumber]="invoiceNumber"
                  [isDisabled]="isDisabledInstallation(device) | async"
                  [isSelected]="isSelectedInstallation(device) | async"
                  (select)="onInstallationSelect(device)"
                  id="installation-{{ device.vin }}"
                ></app-bookable-installation>
              </ng-container>
              <ng-template installation-item #noDevices>
                <div class="no-devices-message" *ngIf="!searchTerm">
                  {{ '+BOOKING.DEVICES.NO_DEVICES' | translate }}
                </div>
              </ng-template>
            </ng-template>
            <mat-paginator
              *ngIf="bookingStore.pagination$ | async as pagination"
              data-at-paginator
              paginator
              [length]="(bookingStore.bookingDevicesWithFilter$ | async)?.length"
              [pageIndex]="pagination.page"
              [pageSize]="pagination.pageSize"
              (page)="onPageChange($event)"
              [disabled]="bookingStore.isLoading$ | async"
            ></mat-paginator>
          </app-booking-devices-list>
        </div>
      </div>
      <div
        class="devices-summary-wrapper"
        *ngrxLet="bookingStore.selectedInstallationsCount$ as selectedInstallationsCount"
      >
        <ng-container *ngIf="invoiceNumber; else bookingSummary">
          <app-booking-contingent-subscriptions-summary
            (continue)="onContinueBookingContingentSubscription()"
            [anyInstallationSelected]="!!selectedInstallationsCount"
            [isCheckout]="false"
          ></app-booking-contingent-subscriptions-summary>
        </ng-container>
        <ng-template #bookingSummary>
          <app-booking-summary
            (continue)="onContinue()"
            [anyInstallationSelected]="!!selectedInstallationsCount"
            [isCheckout]="false"
          ></app-booking-summary>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>
